import { all, takeLatest, put, race, take, select } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { openDialog, closeDialog } from '../../../../services/dialog/actions'
import { importGroupMembersRequest, setupImportResultsState } from './actions'
import {
    loadGroupMembers,
    changeEntityStackGroupMembers,
} from '../../../../scenes/Gnosus/components/GroupStack/actions'
import { groupStackSelector } from '../../../../scenes/Gnosus/components/GroupStack/selectors'
import { activeGroupIdSelector, groupMembersSelector } from './selectors'
import { DATA_PATH, FULL_PATH, IMPORT_GROUP_MEMBERS, IMPORT_GROUP_MEMBERS_REQUEST } from './constants'

function* importGroupMembersRequestSaga(_action) {
    const {
        data: { members, country },
    } = _action
    const groupId = yield select(activeGroupIdSelector)
    let importing = true
    let importResults = []

    yield put(setupImportResultsState(importResults, importing, { imported: false }))

    const {
        activeGroup,
        groupData: { page, rows },
    } = yield select(groupStackSelector)

    const result = yield all({
        response: race({
            success: take(`${IMPORT_GROUP_MEMBERS_REQUEST}_${SUCCESS}`),
            failed: take(`${IMPORT_GROUP_MEMBERS_REQUEST}_${FAILED}`),
        }),
        request: put(importGroupMembersRequest(members, groupId, country)),
    })

    if (result.response.success) {
        importResults = _.get(result, DATA_PATH)
        const { duplicated, exists, notFound, ok, total } = _.get(result, FULL_PATH)

        const group = yield select(groupMembersSelector, _.toString(groupId))

        const currentMembersCount = group.get('members') || 0
        const nextMembersCount = currentMembersCount + ok

        importing = false

        yield put(changeEntityStackGroupMembers(groupId, nextMembersCount))

        yield put(loadGroupMembers(activeGroup, page, rows))
        yield put(
            setupImportResultsState(importResults, importing, {
                duplicated,
                exists,
                notFound,
                ok,
                total,
                imported: true,
            })
        )
    } else if (result.response.failed) {
        const dialogSettings = {
            header: { textId: 'limit', icon: 'warning' },
            question: { textId: 'importLimitError' },
            buttons: ['ok'],
        }
        yield put(closeDialog('groupMembersImport'))
        yield put(openDialog('confirm', activeGroup, dialogSettings))
    }

    return null
}

export default function* groupMembersImportSaga() {
    yield all([yield takeLatest(IMPORT_GROUP_MEMBERS, importGroupMembersRequestSaga)])
}
